'use client';

import { Combobox as ComboboxPrimitive } from '@base-ui/react';
import { cn } from '../../../lib/utils';
import { useComboboxContextOptional } from './combobox-context';

export const ComboboxList = ({ className, children, ...props }: ComboboxPrimitive.List.Props) => {
  const ctx = useComboboxContextOptional();

  return (
    <ComboboxPrimitive.List
      data-slot="combobox-list"
      className={cn(
        // overscroll-contain: prevents scroll chaining and signals to iOS Safari that this element owns its scroll
        'pointer-events-auto flex max-h-[300px] flex-col overflow-y-auto overscroll-contain p-2 scrollbar-thin',
        ctx?.multiple ? 'gap-0.5' : 'gap-0',
        className,
      )}
      // react-remove-scroll (used by Radix Dialog in modal mode) attaches non-passive bubble-phase handlers on
      // `document` for both `wheel` (desktop) and `touchmove` (mobile) and calls preventDefault() on portals
      // outside the dialog DOM tree. Stopping propagation here prevents the events from reaching document,
      // so the scroll lock never fires and the list scrolls normally on both desktop and mobile.
      onWheel={(e) => e.stopPropagation()}
      onTouchMove={(e) => e.stopPropagation()}
      {...props}>
      {children}
    </ComboboxPrimitive.List>
  );
};
